import { isEmpty } from 'lodash-es';
import { useCallback, useEffect, useState } from 'react';
import { fetchEnv, getApiUrl, monitorStorage, NODE_ENV } from '../utils';
import { useSharedGlobalState } from './useSharedGlobal';
import { actions, request } from '@core/shared';
import { useNavigate, useLocation } from 'react-router-dom';
import { Thing } from '../components/Auth/Thing/auth';
export const useAuthLogin = ({ authLoginType, mode, }) => {
    const { _initStateByKey, _initStateByObj } = useSharedGlobalState();
    const [status, setStatus] = useState('loading');
    const navigate = useNavigate();
    const location = useLocation();
    const loginPath = '/user/login';
    _initStateByKey('authLoginType', authLoginType);
    const authLogin = useCallback(async (API_URL) => {
        monitorStorage();
        const userParams = {
            path: `${API_URL}/auth`,
            allow: [
                '/register',
                '/forgetPassword',
                '/m/portal/public/autoAccess.html',
                '/m/portal/public/public.html',
                '/m/portal/magr',
                '/m/82522199059099734/project/analyseApp',
                '/construction-site/home',
                '/construction-site/projectAmap',
            ],
            urlHref: window.location.origin + window.location.pathname,
            search: window.location.search,
            onFinish: (search) => {
                // 路由无刷新处理
                // window.history.replaceState(null, '', location.pathname + search);
                navigate(location.pathname + search, { replace: true });
            },
        };
        const userInfo = await Thing().init({ ...userParams, mode, authLoginType });
        if (isEmpty(userInfo)) {
            setStatus('loading');
        }
        else {
            request.extendOptions({ prefix: getApiUrl(authLoginType) });
            setStatus('read');
        }
    }, []);
    useEffect(() => {
        actions.setThing(Thing);
        //获取json 配置
        fetch('/public/global/config.json').then((res) => {
            res.json().then((config) => {
                _initStateByObj({ ...config });
                if (NODE_ENV === 'production') {
                    // 表示 已经请求过配置了
                    if (window['PUBK']) {
                        authLogin(window[`API_URL_${authLoginType}`]);
                    }
                    else {
                        fetchEnv(mode, authLoginType)
                            .then((res) => {
                            Object.entries(res).forEach(([a, b]) => {
                                window[a] = b;
                            });
                            if (window.location.pathname !== loginPath) {
                                authLogin(window[`API_URL_${authLoginType}`]);
                            }
                        })
                            .catch((e) => {
                            console.error(e);
                            authLogin(process.env.dotenv[`API_URL_${authLoginType}`]);
                        });
                    }
                }
                else {
                    if (window.location.pathname !== loginPath) {
                        authLogin(process.env.dotenv[`API_URL_${authLoginType}`]);
                    }
                }
            });
        });
    }, []);
    return status;
};
